import React, { Component } from "react";
import Appbar from "./appbar";
import Signbutton from "../forms/button";
import { Input } from "../forms/input";
import DemoCarousel from "../auth/carsouel";
import { connect } from "react-redux";
import { generateOtp } from "../../store/actions";
import { QueryAssistant } from "../home/home";
import Footer from "./footer";
class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: { value: "" },
      arnCode: { value: "" },
      password: { value: "" },
      confirmPassword: { value: "" },
      showPassword: false,
      confirmShowPassword: false,
    };
  }

  changeValue = (label) => (event) => {
    if (label === "arnCode" && event.target.value.length <= 20) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label !== "arnCode") {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;
    this.setState({
      [label]: {
        value,
        isError: !value,
        errorMessage: `${
          label === "userId"
            ? "User ID"
            : label === "password"
            ? "Password"
            : label === "arnCode"
            ? "ARN Code"
            : label === "confirmPassword"
            ? "Confirm Password"
            : label
        } is mandatory`,
      },
    });
  };

  generateOtp = async () => {
    const { showPassword, confirmShowPassword, ...others } = this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => {
      return !!this.state[key].value;
    });
    const isPasswordEqual =
      this.state.password.value === this.state.confirmPassword.value;
    if (!findError) {
      keys.forEach((key) => {
        !this.state[key].value &&
          this.setState({
            [key]: {
              ...this.state[key],
              isError: true,
              errorMessage: `${
                key === "userId"
                  ? "User ID"
                  : key === "password"
                  ? "Password"
                  : key === "arnCode"
                  ? "ARN Code"
                  : key === "confirmPassword"
                  ? "Confirm Password"
                  : key
              } is mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !this.state[key].value);
      switch (firstErroredKey) {
        case "userId":
          this.userIdField.focus();
          break;
        case "password":
          this.passwordField.focus();
          break;
        case "arnCode":
          this.arnCodeField.focus();
          break;
        case "confirmPassword":
          this.confirmPasswordField.focus();
          break;
      }
      return;
    }
    if (!isPasswordEqual) {
      this.setState({
        confirmPassword: {
          ...this.state.confirmPassword,
          isError: true,
          errorMessage: "The Password and Confirm Password do not match",
        },
      });
      this.confirmPasswordField.focus();
      return;
    }

    const payload = {
      UserId: this.state.userId.value,
      ARNCode: `ARN-${this.state.arnCode.value}`,
      OTPMsg: Math.floor(100000 + Math.random() * 900000),
      customfund: "189",
    };
    const response = await this.props.generateOtp(payload);
    if (response) {
      this.props.history.push({
        pathname: "/otp",
        state: { payload: { ...payload, password: this.state.password.value } },
      });
    }
  };

  goTermsConditions = () => {
    this.props.history.push("/terms-conditions");
  };

  render() {
    const { userId, password, arnCode, confirmPassword } = this.state;

    return (
      <div className="login-container">
        {/* <QueryAssistant /> */}
        <Appbar />
        <div className="login-without-appbar">
          <DemoCarousel />
          <div className="login-right-div" style={{ overflow: "scroll" }}>
            <div>
              {/* <div className="login-title">Sign up</div> */}
              <div className="form_tabs_list">
                <span
                  className="sign_up_btn sign_btn mouse-pointer"
                  onClick={() => this.props.history.push("./login")}
                >
                  Sign In
                </span>
                <span
                  className="sign_in_btn sign_btn mouse-pointer"
                  onClick={() => this.props.history.push("./register")}
                >
                  Sign Up
                </span>
              </div>

              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="User ID"
                  image={"/images/id-card.svg"}
                  autoFocus={true}
                  value={userId.value}
                  onChange={this.changeValue("userId")}
                  // onBlur={this.showError("userId")}
                  isShowError={userId.isError}
                  errorMessage={userId.errorMessage}
                  inputref={(ele) => (this.userIdField = ele)}
                  // onKeyPress={this.keyPress("userId")}
                  placeholder={"Please enter your User ID"}
                />
              </div>
              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="ARN"
                  errorMessage={arnCode.errorMessage}
                  image={"/images/id-card.svg"}
                  value={arnCode.value}
                  onChange={this.changeValue("arnCode")}
                  // onBlur={this.showError("arnCode")}
                  isShowError={arnCode.isError}
                  inputref={(ele) => (this.arnCodeField = ele)}
                  // onKeyPress={this.keyPress("arnCode")}
                />
              </div>

              <Input
                maxLength={50}
                name="Password"
                errorMessage={password.errorMessage}
                type={!!this.state.showPassword ? "text" : "password"}
                height={15}
                onClick={() =>
                  this.setState({
                    showPassword: !this.state.showPassword,
                  })
                }
                image={"/images/locked.svg"}
                image2={
                  !!this.state.showPassword
                    ? "/images/Bajaj_eye.svg"
                    : "/images/Bajaj_eye_hide.svg"
                }
                value={password.value}
                onChange={this.changeValue("password")}
                // onBlur={this.showError("password")}
                isShowError={password.isError}
                inputref={(ele) => (this.passwordField = ele)}
                // onKeyPress={this.keyPress("password")}
                placeholder={"Please enter your Password"}
              />
              <div className="password-regualations input-margin">
                <span className="pass-star">*</span> Password should be at least
                8 characters in length, should contain at least 1 UPPERCASE
                alphabet (A-Z), 1 special character and 1 numeric value (0-9)
              </div>
              <Input
                maxLength={50}
                name="Confirm Password"
                errorMessage={confirmPassword.errorMessage}
                type={!!this.state.confirmShowPassword ? "text" : "password"}
                height={15}
                onClick={() =>
                  this.setState({
                    confirmShowPassword: !this.state.confirmShowPassword,
                  })
                }
                image={"/images/locked.svg"}
                image2={
                  !!this.state.confirmShowPassword
                    ? "/images/Bajaj_eye.svg"
                    : "/images/Bajaj_eye_hide.svg"
                }
                value={confirmPassword.value}
                onChange={this.changeValue("confirmPassword")}
                // onBlur={this.showError("confirmPassword")}
                isShowError={confirmPassword.isError}
                inputref={(ele) => (this.confirmPasswordField = ele)}
                // onKeyPress={this.keyPress("confirmPassword")}
                placeholder={"Please confirm your Password"}
              />
              <Signbutton
                buttontitle="Generate OTP"
                onClick={this.generateOtp}
              />
              {/* <div className="login-no-account">
               Already have an account?
                <span
                  className="login-no-account-span mouse-pointer"
                  onClick={() => this.props.history.push("/login")}
                >
                  Sign in
                </span>
              </div> */}
              <div className="login-terms-conditions">
                <a
                  style={{
                    fontSize: 15,
                    color: "#005DAC",
                    textDecoration: "underline",
                  }}
                  href={"/terms-conditions"}
                  target="_blank"
                >
                  Terms and Conditions*
                </a>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default connect(null, { generateOtp })(Register);
